import { connect } from 'react-redux';

import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { KNM_NOTICE_INFO } from 'CorePackage/MainModule/routes/routes';
import { NOTICE_DATE_BLOCK_ID, NOTICE_METHOD_BLOCK_ID } from 'KnmPackage/MainModule/constants/fieldsElementsIds';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { Section } from 'UIPackage/FormModule/components/Section';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { SelectInputFieldAutoOptions } from 'UIPackage/MainModule/components/SelectInputFieldAutoOptions';

interface IKnmNoticeInfoProps {
  watchOnly: boolean;
}

const KnmNoticeInfoWithoutStore = ({ watchOnly }: IKnmNoticeInfoProps) => {
  return (
    <Section
      title="Информация об уведомлении проверяемого лица о проведении КНМ"
      id={NOTICE_DATE_BLOCK_ID}
      titleId={KNM_NOTICE_INFO}
    >
      <Row>
        <FieldBlock label="Дата уведомления" color="black" placementLabel="left" size="half">
          <DatePickerField
            className="shared-row-field"
            name="noticeDate"
            disabled={watchOnly}
            minDate={new Date('01-01-2014')}
          />
        </FieldBlock>
        <FieldBlock
          label="Способ уведомления"
          color="black"
          placementLabel="left"
          size="half"
          id={NOTICE_METHOD_BLOCK_ID}
        >
          <SelectInputFieldAutoOptions
            className="shared-row-field"
            name="noticeMethod"
            optionName={CommonCatalogsNamesEnum.KNM_NOTICE_METHODS}
            disabled={watchOnly}
            size="medium"
          />
        </FieldBlock>
      </Row>
    </Section>
  );
};

export const KnmNoticeInfo = connect()(KnmNoticeInfoWithoutStore);
